// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"45a5e056","223":"746d1d27","457":"8e01c432","724":"87c9bfa5","803":"b74b775b","851":"0994333a","859":"474013e8"}[chunkId] + ".chunk.js";
};